import React from "react";
import SEO from "../components/head";
import Layout from "../components/layout";
import Wrap from "../components/wrap";
import { EventProvider } from '../context/EventProvider';
import { StrapiSourceData } from '../interfaces/strapi';

const News = ({ pageContext }: { pageContext: StrapiSourceData }) => {
 return (
   <EventProvider data={pageContext}>
       <Layout>
      <Wrap />
    </Layout>
   </EventProvider>
 );
};

export default News;

export const Head = ({ pageContext }: { pageContext: StrapiSourceData }) => {
 return (
   <EventProvider data={pageContext}>
     <SEO title="News" />
   </EventProvider>
 );
};
